import _ from 'lodash';

import {NewFeatureActionTypes as actionTypes } from './NewFeatureActions';
import {getGroupName} from "./groupNames";

const initialState = {
  overlayVisible: false,
  group: "",
  edit: null,
  isServerData: false,
  matchingProducts: [],
  lightFeaturesGroups: {},
  hasKitchen: false,
  hasBathroom: false,
  filterGroups: [],
  featureDefinitionId: null,
  bundledFeaturesQuantities: {},
};

export const formatEditData = (feature) => {
  if(!feature) return null;

  let name = feature.fabricatorData.displayName;
  if((!name || _.trim(name).length === 0) && feature.name) {
    name = feature.name;
  }

  return {
    id: feature.fabricatorData.fabFeat_id || feature.fabricatorData.id || 0,
    unlinkedData: feature.fabricatorData.unlinkedData,
    name: name,
    sku : feature.fabricatorData.sku || '',
    model: feature.fabricatorData.model || '',
    description: feature.fabricatorData.description || feature.description,
    subDescription: feature.fabricatorData.subDescription || '',
    unit: feature.fabricatorData.unit || feature.unit,
    toolSettings: feature.fabricatorData.toolSettings || [],
    hideUnitLabel: feature.fabricatorData.hideUnitLabel || false,
    productNotForSale: feature.fabricatorData.productNotForSale || false,
    employeesOnly: feature.fabricatorData.employeesOnly || false,
    hideQuantity: feature.fabricatorData.hideQuantity || false,
    defaultQuantity: feature.fabricatorData.defaultQuantity || 1,
    thumbnailImageUrl: feature.fabricatorData.imageUrl || feature.imageUrl,
    metaData: feature.fabricatorData.metaData || feature.metaData,
    autoAddToCart: feature.fabricatorData.autoAddToCart || false,
    notTaxable: feature.fabricatorData.notTaxable || false,
    priceEditable: feature.fabricatorData.priceEditable || false,
    useStonePricing: feature.fabricatorData.useStonePricing === null ? true : feature.fabricatorData.useStonePricing,
//----INSTALLATION
    installations: _.map(feature.fabricatorData.installations || feature.installations, i => i.fabricatorInstallation_id),
//----FILTERS
    selectedFilters: (feature.fabricatorData.filters && feature.fabricatorData.filters.length > 0)
      ?  _.map(feature.fabricatorData.filters.filter(f => f.fabricatorFilterOverrideEnabled !== false), f => f.filterGroupValue_id)
      : _.map(feature.filters, f => f.filterGroupValue_id),
    defaultFilters: feature.filters,
    fabricatorOverrideEnabledFilters: _.map(feature.fabricatorData.filters.filter(f => f.fabricatorFilterOverrideEnabled === false), f => f.filterGroupValue_id),
    featDefFilters: feature.fabricatorData.featDefFilters,
//----GALLERY
    galleryEnabled: feature.fabricatorData.galleryEnabled || false,
    galleryImages: feature.fabricatorData.galleryImages || [],
//----COMPLEX LOGIC
    complexLogic: feature.fabricatorData.complexLogic,
//----DISPLAY LOGIC
    displayLogicEnabled: feature.fabricatorData.displayLogic && feature.fabricatorData.displayLogic.enabled,
    displayLogicAction: feature.fabricatorData.displayLogic && feature.fabricatorData.displayLogic.action,
    displayLogicRules: feature.fabricatorData.displayLogic && feature.fabricatorData.displayLogic.displayRules || [],
// Layers
    nakedName: feature.nakedName,
    originalNakedName: feature.originalNakedName,
    complex: feature.complex,
    relatedFeatures: feature.fabricatorData.relatedFeatures || feature.relatedFeatures || [],
    bundledFeatures: feature.fabricatorData.bundledFeatures || feature.bundledFeatures || [],
    groupedFeaturesByName: feature.groupedFeaturesByName || []
  };
}

export default function newInstallationGroupReducer(state = initialState, action) {
  const newState = {...state};
  switch(action.type) {
    case actionTypes.SHOW_OVERLAY_NEW:
      newState.overlayVisible = action.payload.overlayVisible;
      newState.featureDefinitionId = action.payload.featureDefinitionId;
      newState.group = action.payload.group;
      break;
    case actionTypes.SET_NEW_FEATURE_DATA:
      const {data} = action.payload;
      newState.edit = formatEditData({fabricatorData: data.fabricatorFeature});
      newState.isServerData = true;
      newState.matchingProducts = data.matchingProducts;
      newState.hasKitchen = data.hasKitchen;
      newState.hasBathroom = data.hasBathroom;
      newState.filterGroups = data.filterGroups;
      newState.installationGroups = data.installationGroups;
      newState.installationUnits = data.installationUnits;
      newState.bundledFeaturesQuantities = data.fabricatorFeature
        ? data.fabricatorFeature.bundledFeaturesQuantities || {}
        : {};
      break;
    case actionTypes.SET_NEW_FEATURE_DATA_RELATED:
        const {lightFeaturesGroups} = action.payload;
        newState.lightFeaturesGroups = lightFeaturesGroups;
        break;
    case actionTypes.RESET_FEATURE_DATA:
      return Object.assign({}, initialState);
    case actionTypes.SET_BUNDLE_Q_TIES:
      return Object.assign({}, state, {...action.payload});
  }

  return newState;
}


export function groupNameByMeta({groupName, metaData, layout, name}) {
  return getGroupName(groupName, metaData, layout, name);
}

